import { stliteStyledPromiseToast } from "./promise";
export class StliteKernelWithToast {
    kernel;
    constructor(kernel) {
        this.kernel = kernel;
    }
    writeFile(...args) {
        return stliteStyledPromiseToast(this.kernel.writeFile(...args), {
            error: "Failed to write the file",
        });
    }
    renameFile(...args) {
        return stliteStyledPromiseToast(this.kernel.renameFile(...args), {
            error: "Failed to rename the file",
        });
    }
    unlink(...args) {
        return stliteStyledPromiseToast(this.kernel.unlink(...args), {
            error: "Failed to remove the file",
        });
    }
    readFile(...args) {
        return stliteStyledPromiseToast(this.kernel.readFile(...args), {
            error: "Failed to read the file",
        });
    }
    install(...args) {
        return stliteStyledPromiseToast(this.kernel.install(...args), {
            pending: "Installing",
            success: "Successfully installed",
            error: "Failed to install",
        });
    }
    reboot(...args) {
        return stliteStyledPromiseToast(this.kernel.reboot(...args), {
            pending: "Rebooting",
            success: "Successfully rebooted",
            error: "Failed to reboot",
        });
    }
}
//# sourceMappingURL=stlite-kernel-with-toast.js.map